<cx-searchbox
  [quickOrder]="true"
  [searchValueClear]="clearSearchValue"
  (selectedProductEvent)="onProductSelected($event)"
  [config]="QUICKORDER_SEARCH_BOX_CONFIG">
</cx-searchbox>

@if (quickOrderDetail && !productInfo?.flu) {
  <div class="mt-2 mb-4 custom-quick-order">
    <app-contracts-partial
      [contractFromCartApi]="contractFromCartApi"
      [conditions]="productInfo?.conditions"
      [selectedChannel]="selectedChannel"
      [hasMatchingContract]="hasMatchingContract"
      [showPriceGroup]="showPriceGroup"
      [priceGroupToShow]="priceGroupToShow"
      (selectedContract)="onSelectedContract($event)"
      (selectPriceGroup)="onSelectPriceGroup($event)"
    />

    <!-- Price / Unit -->
    <div class="unit-calc">
      <div class="d-flex justify-content-around flex-wrap-reverse w-100 mb-4 mt-4">
        <div class="price-details">
          <div class="mb-2 text-fixed-legal-copy color-grey-dark font-weight-bold">
            {{ productInfo.actualPotency ? ('plp.unitPrice' | cxTranslate) : ('plp.yourPrice' | cxTranslate) }}
            {{ ProductUtils.getUnitTranslation(selectedChannel) }}
          </div>

          <div class="c-heading c-heading-h3">
            @if (displayLocalPriceAsLocalCurrency() && !checkIfUnavailableToOrder()) {
              <span>{{ productInfo?.price?.value | localCurrency }}</span>
            }

            @if (showContract && contractSelected && priceToShow && selectedChannel === PriceChannel.PUBLIC) {
              <span>{{ priceToShow | localCurrency }}</span>
            }
          </div>
        </div>

        @if (!productInfo?.discontinued && productInfo?.available) {
          <div class="units mb-3">
            <label class="mb-2 text-center text-fixed-legal-copy font-weight-bold color-grey-dark" for="{{ 'prodQuantity' + productInfo.code + 'q' }}">
              {{ 'plp.units' | cxTranslate }}
              {{ ProductUtils.getUnitTranslation(selectedChannel) }}
            </label>
            <div class="d-flex justify-content-center align-items-center">
              <span id="{{ 'unitMinus' + productInfo?.code + 'q' }}" class="d-none"></span>
              <span id="{{ 'unitMinusDisable' + productInfo?.code + 'q' }}" class="d-none"></span>
              <span id="{{ 'unitPlus' + productInfo?.code + 'q' }}" class="d-none"></span>
              <span id="{{ 'unitPlusDisable' + productInfo?.code + 'q' }}" class="d-none"></span>

              <button
                class="c-count-change-btn disabled"
                id="{{ 'minusIcon' + productInfo.code + 'q' }}"
                (click)="performQuantityComputation(2)">
                <em class="fa fa-minus" aria-hidden="true"></em>
              </button>
              <input
                [class]="{
                    'custom-quick-order__quantityPublic': selectedChannel === PriceChannel.PUBLIC,
                    'custom-quick-order__quantityPrivate': selectedChannel === PriceChannel.PRIVATE
                  }"
                autoSizeInput
                [includeBorders]="true"
                type="number"
                class="prod-quantity text-center"
                value="{{ conditionsForCartonsLogicMeet ? productInfo.numberOfUnitsPerCarton : '1' }}"
                (blur)="performQuantityComputation(null)"
                id="{{ 'prodQuantity' + productInfo.code + 'q' }}"
                min="1"
                max="{{ProductUtils.getMaximumQuantity(selectedChannel)}}"/>
              <button
                class="c-count-change-btn"
                id="{{ 'plusIcon' + productInfo.code + 'q' }}"
                (click)="performQuantityComputation(1)">
                <em class="fa fa-plus" aria-hidden="true"></em>
              </button>
            </div>

            @if (conditionsForCartonsLogicMeet) {
            <div class="w-100 mt-1 d-flex justify-content-center text-center" id="{{'noOfCartons' + productInfo?.code + 'q'}}">
              <span class="red">min 1 cx embarque</span>
            </div>
            }

          </div>
        }
      </div>
    </div>

    <app-add-to-cart-button
      [productInfo]="productInfo"
      [selectedChannel]="selectedChannel"
      [userDetails]="userDetails"
      [contractSelected]="contractSelected"
      [priceToShowGroupId]="priceToShowGroupId"
      [contractSelectedId]="contractSelectedId"
      [carts]="carts"
      [enableBtn]="enableBtn"
      [fullWidthButton]="true"
      [isQuickOrder]="true"
    />
  </div>
}
